import React from 'react';
import { Button, Divider, Grid, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../store/reduxHooks';
import { toggleTheme } from '../../../store/uxSlice';

export default function SettingsPage(props: any) {
  const {lightTheme}  = useAppSelector((state)=>state.ux);
  const dispatch = useAppDispatch();
  const btnClick = ()=>{
    dispatch(toggleTheme())
  }
  return (
    <>
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12}>
          <Typography variant='h4' mb={1}>
            Settings
          </Typography>
          
          <Divider sx={{mb:2}} />

          <Button variant='contained' onClick={btnClick}>
            Swap the to {lightTheme?'Dark':'Light'}
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
